/* eslint-disable no-unused-vars */
export enum AppId {
	Default = 'Default',
	Befare = 'Befare',
	MinElektriker = 'MinElektriker',
	MinRorlegger = 'MinRorlegger',
	Smart = 'Smart',
}
